// Single source for the project name used as a build-time fallback.
//
// At runtime the name almost always comes from the database
// (`settings.companyName`, editable in Админ → Настройки). This constant is
// what renders before those settings load and on screens that have no access
// to them (the login page, the admin sidebar, the document title).
//
// Set VITE_SITE_NAME in .env when cloning the platform for a new project.
export const SITE_NAME = import.meta.env.VITE_SITE_NAME || 'Моят проект';
